/**
 * 11332协议自动化识别expID
 * 识别方式：
 * 1、在所有cgi请求的返回结果中，自动检查是否有 res.report_info.exp_rpt_list
 * 2、如有，则注入到window.expRptList
 * 3、每条上班
 * 
 */
import env from '../common/env.js';
let exportData;
if(!env.isCSR) {
    ;(function(win, doc) {
        "use strict";
        function calExpID(_o) {
            try{
                if(!window._expRptList_ || window._expRptList_.length === 0){
                    return {exp_id: 0, reason_id : 0};
                }
    
                var list = window._expRptList_;
                var item;
                for( var i = 0, len = list.length; i < len; i++ ){
                    item = list[i];
    
                    if(item.scene_id    && item.scene_id + ""    && item.scene_id + ""    !== _o.iSceneId + ""){
                        continue;
                    }
                    if(item.game_id     && item.game_id + ""     && item.game_id + ""     !== _o.sGameId + ""){
                        continue;
                    }
                    if(item.ui_area     && item.ui_area + ""     && item.ui_area + ""     !== _o.iUIArea + ""){
                        continue;
                    }
                    // if(item.reason_id   && item.reason_id + ""   && item.reason_id + ""   !== _o.iReasonID + ""){
                    //     continue;
                    // }
                    if(item.position_id && item.position_id + "" && item.position_id + "" !== _o.iPositionId + ""){
                        continue;
                    }
                    return {exp_id: item.exp_id || 0, reason_id : item.reason_id || 0}
                }
    
                return {exp_id: 0, reason_id : 0};
            }catch(e){
                return {exp_id: 0, reason_id : 0};
            }
        }
        exportData = calExpID;
    })(window, document);
}else{
    exportData = {}
}
export default exportData;







